import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const saveWellnessAssessment = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/assessment`, data);
        return response.data;
    } catch (error) {
        console.error("Error saving wellness assessment:", error);
        throw error;
    }
};

export const getWellnessAssessments = async (userId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/assessment/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching wellness assessments:", error);
        throw error;
    }
};
